import { readable } from 'svelte/store';
export const chapters = readable({}, start);
function start(set) {
    // Adapt Array(11) with the number of the available chapters
    const promises = Array.from(Array(11).keys()).map(async (i) => {
        const scenarioFile = await fetch(`chapters/chapitre${String(i).padStart(2, '0')}.json`);
        if (scenarioFile.ok) {
            const scenario = await scenarioFile.text();
            return JSON.parse(scenario);
        }
        else {
            throw new Error(`Impossible de lire le scénario n°${String(i).padStart(2, '0')}`);
        }
    });
    // Transform Array<Scenario> into an adressable Hash {[scenarioId]: Scenario}
    Promise.all(promises).then((chaptersArray) => {
        const results = chaptersArray.reduce((acc, scenario) => (Object.assign(Object.assign({}, acc), { [scenario.metadata.chapter]: scenario })), {});
        set(results);
    }).catch((e) => {
        set({ error: e.message });
    });
    return function stop() { }; // Nothing to do when stopping
}
